import { Helmet } from "react-helmet";

interface MetaTagsProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl?: string;
}

const MetaTags = ({ title, description, keywords, canonicalUrl }: MetaTagsProps) => {
  const siteName = 'Bektaş Temizlik';
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteName} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  );
};

export default MetaTags;
